import { render } from "./TableDataFormulir.vue?vue&type=template&id=0d3ed05e"
import script from "./TableDataFormulir.vue?vue&type=script&lang=js"
export * from "./TableDataFormulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__